import { Response } from '@/core'
import {
  SaveFlightSearchParams,
  FlightListResponse,
  FlightUpgradeParams,
  FlightUpgradeOptionsResponse,
  FlightAddParams,
  PackageBaseParams,
  PackageApiBuilder,
} from './package.api.types'

export const flightsEndpoints = (builder: PackageApiBuilder) => ({
  saveFlightSearchParams: builder.mutation<Response<void>, SaveFlightSearchParams>({
    query: ({ params, data }: SaveFlightSearchParams) => ({
      url: `/package/flight/params`,
      method: 'put',
      params,
      data,
    }),
  }),
  getFlightList: builder.mutation<Response<FlightListResponse>, SaveFlightSearchParams>({
    query: ({ params, data }: SaveFlightSearchParams) => ({
      url: `/package/flight/list`,
      method: 'post',
      params,
      data,
    }),
  }),
  getFlightUpgrades: builder.mutation<Response<FlightUpgradeOptionsResponse>, FlightUpgradeParams>({
    query: ({ params, data }: FlightUpgradeParams) => ({
      url: `/package/flight/upgrade`,
      method: 'post',
      params,
      data,
    }),
  }),
  addFlight: builder.mutation<Response<void>, FlightAddParams>({
    query: ({ params, data }: FlightAddParams) => ({
      url: `/package/flight/add`,
      method: 'post',
      params,
      data,
    }),
  }),
  removeFlight: builder.mutation<Response<void>, PackageBaseParams>({
    query: ({ sessionId }) => ({
      url: `/package/flight/remove`,
      method: 'put',
      params: { sessionId },
    }),
  }),
})
